import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatCad, type InvoiceSummary } from "@shared/modules/x-atelier";
import { Card } from "../../../core/components/ui/card";
import { getInvoiceSummary } from "../lib/api";

/** Accueil : ce qui reste à encaisser, ce qui est en souffrance, le facturé du mois. */
export function InvoicesWidget() {
  const [summary, setSummary] = useState<InvoiceSummary | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    getInvoiceSummary()
      .then((s) => {
        setSummary(s);
        setFailed(false);
      })
      .catch(() => setFailed(true));
  }, []);

  const late = summary?.outstanding.overdueCount ?? 0;
  return (
    <Card
      title="Factures"
      subtitle="À encaisser et facturé ce mois-ci"
      actions={<Link to="/factures">Voir les factures</Link>}
    >
      {failed ? (
        <p className="atelier-widget__empty">Chiffres indisponibles pour l'instant.</p>
      ) : (
        <dl className="atelier-widget__stats atelier-widget__stats--money">
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">À encaisser</dt>
            <dd className="atelier-widget__value">
              {summary ? formatCad(summary.outstanding.dueCents) : "—"}
            </dd>
            <dd className="atelier-widget__note">
              {summary
                ? `${summary.outstanding.count} facture${summary.outstanding.count > 1 ? "s" : ""}`
                : ""}
            </dd>
          </div>
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">En souffrance</dt>
            <dd className={`atelier-widget__value${late > 0 ? " is-late" : ""}`}>
              {summary ? formatCad(summary.outstanding.overdueCents) : "—"}
            </dd>
            <dd className="atelier-widget__note">
              {summary ? `${late} facture${late > 1 ? "s" : ""}` : ""}
            </dd>
          </div>
          <div className="atelier-widget__stat">
            <dt className="atelier-widget__label">Ce mois-ci</dt>
            <dd className="atelier-widget__value">
              {summary ? formatCad(summary.month.totalCents) : "—"}
            </dd>
            <dd className="atelier-widget__note">
              {summary ? `${summary.month.count} facture${summary.month.count > 1 ? "s" : ""}` : ""}
            </dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
